import React from 'react';
import { ArrowUpIcon, ArrowDownIcon } from '../icons/OverviewIcons';

const OverviewCard = ({ label, value, growthRate, Icon }) => {
  const isDecreasing = growthRate < 0;

  return (
    <div className="rounded-10 bg-white p-6 shadow-1 dark:bg-gray-dark">
      <Icon />

      <div className="mt-6 flex items-end justify-between">
        <dl>
          <dt className="mb-1.5 text-heading-6 font-bold text-dark dark:text-white">
            {value}
          </dt>
          <dd className="text-sm font-medium text-dark-6">{label}</dd>
        </dl>

        <dl
          className={`text-sm font-medium ${
            isDecreasing ? 'text-red' : 'text-green'
          }`}
        >
          <dt className="flex items-center gap-1.5">
            {Math.abs(growthRate)}%
            {isDecreasing ? (
              <ArrowDownIcon aria-hidden />
            ) : (
              <ArrowUpIcon aria-hidden />
            )}
          </dt>
          <dd className="sr-only">
            {label} {isDecreasing ? 'Decreased' : 'Increased'} by{' '}
            {Math.abs(growthRate)}%
          </dd>
        </dl>
      </div>
    </div>
  );
};

export default OverviewCard;











